import {ModalType} from "./modal-type";
import {Melody} from "./melody";
import {SubscriberMelody} from "./subscriber-melody";
import {Contact} from "./contact";
import {Group} from "./group";

export class ModalParams {
  show: boolean;
  modalType: ModalType;
  melody: Melody;
  subscriberMelody: SubscriberMelody;
  privetPlusSubscription: boolean;
  contact: Contact;
  group: Group;
  callback: () => void;


  constructor(show: boolean, modalType?: ModalType, melody?: Melody, subscriberMelody?: SubscriberMelody, privetPlusSubscription?: boolean, contact?: Contact,
              group?: Group, callback?: () => void) {
    this.show = show;
    this.modalType = modalType;
    this.melody = melody;
    this.subscriberMelody = subscriberMelody;
    this.privetPlusSubscription = privetPlusSubscription;
    this.contact = contact;
    this.group = group;
    this.callback = callback;
  }
}
